/* Koffi — interacciones propias (prefijo kf-) */
(function () {
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function initReveals(root) {
    var els = (root || document).querySelectorAll('.kf-reveal:not(.kf-visible)');
    if (!els.length) return;
    if (reduce || !('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('kf-visible'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('kf-visible'); io.unobserve(e.target); }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -40px 0px' });
    els.forEach(function (el) { io.observe(el); });
  }

  function initContadores(root) {
    var els = (root || document).querySelectorAll('[data-kf-contar]');
    if (!els.length) return;
    function animar(el) {
      var fin = parseFloat(el.getAttribute('data-kf-contar')) || 0;
      var dec = (String(el.getAttribute('data-kf-contar')).split('.')[1] || '').length;
      if (reduce) { el.textContent = fin.toFixed(dec); return; }
      var dur = 1600, t0 = null;
      function paso(t) {
        if (!t0) t0 = t;
        var p = Math.min((t - t0) / dur, 1);
        var v = fin * (1 - Math.pow(1 - p, 3));
        el.textContent = v.toFixed(dec);
        if (p < 1) requestAnimationFrame(paso);
      }
      requestAnimationFrame(paso);
    }
    if (!('IntersectionObserver' in window)) { els.forEach(animar); return; }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { animar(e.target); io.unobserve(e.target); }
      });
    }, { threshold: 0.5 });
    els.forEach(function (el) { io.observe(el); });
  }

  function initParallax() {
    var imgs = document.querySelectorAll('[data-kf-parallax]');
    if (!imgs.length || reduce) return;
    var ticking = false;
    function update() {
      imgs.forEach(function (img) {
        var r = img.parentElement.getBoundingClientRect();
        var k = parseFloat(img.getAttribute('data-kf-parallax')) || 0;
        var off = (r.top + r.height / 2 - window.innerHeight / 2) * -k / 100;
        img.style.transform = 'translate3d(0,' + off.toFixed(1) + 'px,0) scale(1.06)';
      });
      ticking = false;
    }
    window.addEventListener('scroll', function () {
      if (!ticking) { requestAnimationFrame(update); ticking = true; }
    }, { passive: true });
    update();
  }

  function initColores(root) {
    (root || document).querySelectorAll('[data-kf-colores]').forEach(function (sec) {
      var termo = sec.querySelector('.kf-termo');
      var cuerpo = sec.querySelectorAll('.kf-termo__cuerpo');
      var escena = sec.querySelector('.kf-colores__escena');
      var nombre = sec.querySelector('[data-kf-color-nombre]');
      var btns = sec.querySelectorAll('.kf-swatch');
      btns.forEach(function (b) {
        b.addEventListener('click', function () {
          btns.forEach(function (x) { x.setAttribute('aria-pressed', 'false'); });
          b.setAttribute('aria-pressed', 'true');
          cuerpo.forEach(function (c) { c.style.fill = b.getAttribute('data-color'); });
          if (escena) escena.style.backgroundColor = b.getAttribute('data-fondo');
          if (nombre) nombre.innerHTML = b.getAttribute('data-nombre') + (b.getAttribute('data-nota') ? ' <span>' + b.getAttribute('data-nota') + '</span>' : '');
          if (termo && !reduce) {
            termo.classList.add('kf-cambia');
            setTimeout(function () { termo.classList.remove('kf-cambia'); }, 380);
          }
        });
      });
    });
  }

  function initProducto(root) {
    (root || document).querySelectorAll('[data-kf-producto]').forEach(function (sec) {
      var datos = sec.querySelector('[data-kf-variantes]');
      var variantes = datos ? JSON.parse(datos.textContent) : [];
      var form = sec.querySelector('form[action*="/cart/add"]');
      var inputId = sec.querySelector('input[name="id"]');
      var precio = sec.querySelectorAll('[data-kf-precio]');
      var tachado = sec.querySelectorAll('[data-kf-tachado]');
      var btn = sec.querySelector('[data-kf-anadir]');
      var btnTxt = btn ? btn.querySelector('span') : null;
      var txtOk = btn ? btn.getAttribute('data-txt') : '';
      var txtAgotado = btn ? btn.getAttribute('data-agotado') : '';
      var principal = sec.querySelector('[data-kf-principal]');
      var minis = sec.querySelectorAll('.kf-prod__mini');
      var aviso = sec.querySelector('.kf-prod__aviso');
      var moneda = sec.getAttribute('data-moneda') || 'EUR';
      var locale = document.documentElement.lang || 'es';

      function dinero(c) {
        try { return new Intl.NumberFormat(locale, { style: 'currency', currency: moneda }).format(c / 100); }
        catch (e) { return (c / 100).toFixed(2) + ' ' + moneda; }
      }

      function verImagen(src, srcset, idx) {
        if (!principal || !src) return;
        principal.style.opacity = '0.3';
        var tmp = new Image();
        tmp.onload = function () {
          principal.src = src;
          if (srcset) principal.srcset = srcset;
          principal.style.opacity = '1';
        };
        tmp.src = src;
        minis.forEach(function (m, i) { m.setAttribute('aria-current', i === idx ? 'true' : 'false'); });
      }
      minis.forEach(function (m, i) {
        m.addEventListener('click', function () { verImagen(m.getAttribute('data-src'), m.getAttribute('data-srcset'), i); });
      });

      function actualizar() {
        if (!variantes.length) return;
        var sel = [];
        sec.querySelectorAll('.kf-opcion').forEach(function (fs) {
          var c = fs.querySelector('input:checked');
          sel.push(c ? c.value : null);
          var lbl = fs.querySelector('legend span');
          if (lbl && c) lbl.textContent = c.value;
        });
        var v = variantes.find(function (x) { return x.options.every(function (o, i) { return o === sel[i]; }); });
        if (!v) {
          if (btn) { btn.disabled = true; btnTxt.textContent = txtAgotado; }
          return;
        }
        inputId.value = v.id;
        precio.forEach(function (p) { p.textContent = dinero(v.price); });
        tachado.forEach(function (t) {
          if (v.compare_at_price && v.compare_at_price > v.price) { t.textContent = dinero(v.compare_at_price); t.hidden = false; }
          else t.hidden = true;
        });
        if (btn) { btn.disabled = !v.available; btnTxt.textContent = v.available ? txtOk : txtAgotado; }
        if (v.featured_media && v.featured_media.preview_image) {
          var src = v.featured_media.preview_image.src;
          var idx = -1;
          minis.forEach(function (m, i) { if (m.getAttribute('data-media-id') == v.featured_media.id) idx = i; });
          if (idx > -1) verImagen(minis[idx].getAttribute('data-src'), minis[idx].getAttribute('data-srcset'), idx);
          else verImagen(src + (src.indexOf('?') > -1 ? '&' : '?') + 'width=1200', null, -1);
        }
        if (window.history && window.history.replaceState && sec.hasAttribute('data-url')) {
          window.history.replaceState({}, '', sec.getAttribute('data-url') + '?variant=' + v.id);
        }
      }
      sec.querySelectorAll('.kf-opcion input').forEach(function (i) { i.addEventListener('change', actualizar); });

      var cant = sec.querySelector('.kf-cantidad input');
      sec.querySelectorAll('[data-kf-cant]').forEach(function (b) {
        b.addEventListener('click', function () {
          var n = Math.max(1, (parseInt(cant.value, 10) || 1) + parseInt(b.getAttribute('data-kf-cant'), 10));
          cant.value = n;
        });
      });

      // Añadir al carrito sin salir de la página (cae al envío normal si falla)
      if (form) {
        form.addEventListener('submit', function (ev) {
          if (!window.fetch) return;
          ev.preventDefault();
          if (btn) btn.disabled = true;
          var cartDrawer = document.querySelector('cart-drawer');
          var cartNotif = document.querySelector('cart-notification');
          var fd = new FormData(form);
          var secciones = [];
          if (cartDrawer && cartDrawer.getSectionsToRender) secciones = cartDrawer.getSectionsToRender().map(function (s) { return s.id; });
          else if (cartNotif && cartNotif.getSectionsToRender) secciones = cartNotif.getSectionsToRender().map(function (s) { return s.id; });
          if (secciones.length) { fd.append('sections', secciones.join(',')); fd.append('sections_url', window.location.pathname); }
          fetch((window.routes && window.routes.cart_add_url ? window.routes.cart_add_url : '/cart/add') + '.js', {
            method: 'POST', headers: { 'X-Requested-With': 'XMLHttpRequest', Accept: 'application/javascript' }, body: fd
          }).then(function (r) { return r.json(); }).then(function (res) {
            if (btn) btn.disabled = false;
            if (res.status) { if (aviso) aviso.textContent = res.description || res.message; return; }
            var ui = cartDrawer || cartNotif;
            if (ui && ui.renderContents && res.sections) {
              if (cartDrawer && cartDrawer.classList.contains('is-empty')) cartDrawer.classList.remove('is-empty');
              ui.renderContents(res);
            } else {
              window.location.href = (window.routes && window.routes.cart_url) || '/cart';
            }
          }).catch(function () { form.submit(); });
        });
      }

      // Barra fija en móvil
      var barra = sec.querySelector('.kf-barra');
      if (barra && btn && 'IntersectionObserver' in window) {
        new IntersectionObserver(function (en) {
          barra.classList.toggle('kf-visible', !en[0].isIntersecting && en[0].boundingClientRect.top < 0);
        }).observe(btn);
        barra.querySelector('button').addEventListener('click', function () {
          btn.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'center' });
        });
      }
    });
  }

  function initTodo(root) {
    initReveals(root); initContadores(root); initColores(root); initProducto(root);
  }

  document.addEventListener('DOMContentLoaded', function () { initTodo(document); initParallax(); });
  document.addEventListener('shopify:section:load', function (e) { initTodo(e.target); });
})();
